// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers';
export class Variable {
    bb = null;
    bb_pos = 0;
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsVariable(bb, obj) {
        return (obj || new Variable()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsVariable(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new Variable()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    id(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return this.bb.__string(this.bb_pos + offset, optionalEncoding);
    }
    name(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return this.bb.__string(this.bb_pos + offset, optionalEncoding);
    }
    keyword(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return this.bb.__string(this.bb_pos + offset, optionalEncoding);
    }
    dataType(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return this.bb.__string(this.bb_pos + offset, optionalEncoding);
    }
    defaultValue(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    static startVariable(builder) {
        builder.startObject(5);
    }
    static addId(builder, idOffset) {
        builder.addFieldOffset(0, idOffset, 0);
    }
    static addName(builder, nameOffset) {
        builder.addFieldOffset(1, nameOffset, 0);
    }
    static addKeyword(builder, keywordOffset) {
        builder.addFieldOffset(2, keywordOffset, 0);
    }
    static addDataType(builder, dataTypeOffset) {
        builder.addFieldOffset(3, dataTypeOffset, 0);
    }
    static addDefaultValue(builder, defaultValueOffset) {
        builder.addFieldOffset(4, defaultValueOffset, 0);
    }
    static endVariable(builder) {
        const offset = builder.endObject();
        builder.requiredField(offset, 4); // id
        builder.requiredField(offset, 6); // name
        builder.requiredField(offset, 8); // keyword
        builder.requiredField(offset, 10); // data_type
        return offset;
    }
    static createVariable(builder, idOffset, nameOffset, keywordOffset, dataTypeOffset, defaultValueOffset) {
        Variable.startVariable(builder);
        Variable.addId(builder, idOffset);
        Variable.addName(builder, nameOffset);
        Variable.addKeyword(builder, keywordOffset);
        Variable.addDataType(builder, dataTypeOffset);
        Variable.addDefaultValue(builder, defaultValueOffset);
        return Variable.endVariable(builder);
    }
}
//# sourceMappingURL=variable.js.map